import React from 'react';
import useComparatorSavePreferencesModal from 'utils/hooks/meteorology/useComparatorSavePreferencesModal';
import Dialog from 'components/DesignSystem/Dialog';
import SavePreferencesForm from './savePreferencesForm';

export default function SavePreferencesModal() {
  const { setShowFormModal, isShowingFormModal } = useComparatorSavePreferencesModal();

  return (
    <Dialog
      open={isShowingFormModal}
      dismiss={() => { setShowFormModal(false); }}
      closeButton
    >
      <Dialog.Body>
        <SavePreferencesForm />
      </Dialog.Body>
    </Dialog>
  );
}
